import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import webservice from '../../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../../Service/crypto';
import api from '../../../../api';

export const getcountresived = createAsyncThunk('appCalendar/files', async (data:any) => {
    const dataString = JSON.stringify(data);
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,dataString);
    const token = localStorage.getItem("token");
    const response = await api.fetch('api/Dashboard/getcountresived', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
    })
        .then((response) => response.json())
    const TempData = await AesDecrypt(key,response)

    return TempData;
})

export const getfilestatus = createAsyncThunk('appCalendar/files', async (data: any) => {
    const key = await keyPromise
    const dataString = JSON.stringify(data); // Convert data to JSON string
    const EncParams = await AesEncrypt(key,dataString); // Encrypt the stringified data
    const token = localStorage.getItem("token");

    const response = await api.fetch('api/Dashboard/getfilestatus', {
        method: 'POST',
        body: JSON.stringify(EncParams),
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key,response)
    return TempData;
});

// Counts only ({received, completed, yet_to_start, in_progress, error, regenerated, downloaded}),
// counted on the server: much faster than getfilestatus, which returns one row per file.
export const getfilestatuscounts = createAsyncThunk('dashboard/fileStatusCounts', async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key, JSON.stringify(data));
    const response = await api.fetch('api/Dashboard/getfilestatuscounts', {
        method: 'POST',
        body: JSON.stringify(EncParams),
    }).then((response) => response.json());
    return await AesDecrypt(key, response);
});


export const getapicount = createAsyncThunk('appCalendar/files', async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,data); 
    const response = await api.fetch('api/Dashboard/apicount', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
    })
        .then((response) => response.json())
    // const TempData = AesDecrypt(response)

    return response;
})



export const get_tat = createAsyncThunk('appCalendar/files', async (data: any) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,data);
    const response = await api.fetch('api/Dashboard/gettat', {
        method: 'POST',
        body: JSON.stringify({ EncParams }),
    })
        .then((response) => response.json())
    // const TempData = AesDecrypt(response)

    return response;
})   

interface SelectedDateState {
    selectedBarDate: string;
}

const initialState: SelectedDateState = {
    selectedBarDate: "",
};

const selectedDateSlice = createSlice({
    name: "selectedDate",
    initialState,
    reducers: {
        setSelectedBarDate: (state, action: PayloadAction<string>) => {
            state.selectedBarDate = action.payload;
        },
    },
});

export const { setSelectedBarDate } = selectedDateSlice.actions;
export default selectedDateSlice.reducer;
